import React from "react";

const About = () => {
    return (
        <h1>I am the About page</h1>
    );
}

export default About;